import React, { Component } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { NavigationHeader } from "../../layout/components/navigationheader/NavigationHeader";
import { Card, Button, Row, Col, Form } from "react-bootstrap";
import { saveUrl } from "../../../../../../../actions/sceneActions";
import { URL_SUCCESS_SAVE, SUCCESS_TEXT } from "../../../app/messageText";
import {
  validURL,
  updateURLForIframe,
  customClass,
  getInitialRoute,
} from "../../../../../../../utils";

class UpdateLinks extends Component {
  state = {
    url: null,
    buttonDis: null,
    loader: null,
    errorLink: null,
  };
  
  onTextUrl = (event) => {
    var enterUrl = event.target.value; 
    if (window.location.toString().includes("youtube")) {
      if (enterUrl.includes("youtu.be")) {
        enterUrl = enterUrl.replace("youtu.be/", "www.youtube.com/watch?v=");
        this.setState({ url: enterUrl, errorLink: null });
      } else if (enterUrl.includes("youtube")) {
        this.setState({ url: enterUrl, errorLink: null });
      } else {
        this.setState({ url: null, errorLink: 'youtube' });
      }
    } else if (window.location.toString().includes("vimeo")) {
      if (enterUrl.includes("vimeo")) {
        this.setState({ url: enterUrl, errorLink: null });
      } else {
        this.setState({ url: null, errorLink: 'vimeo' });
      }
    } else {
      if (enterUrl.includes("https://")) {
        this.setState({ url: enterUrl, errorLink: null });
      } else {
        this.setState({ url: null, errorLink: 'link' });
      }
    }
  };

  onSaveUrl = (event) => {
    const { match, location, param } = this.props;
    let contentMixId = param.contentMixId;
    let positionID = param.positionID;
    let wallId = match.params.wallId;
 
    if (match.url) {
      if (match.url.includes("vimeo") && location.pathname.includes("vimeo")) {
        let splitPath = `/studio/${wallId}/links/vimeo/`;
        let replaceData = location.pathname.replace(splitPath, "");
        let DataID = replaceData.split("/");
        if (DataID && DataID.length > 0) {
          contentMixId = DataID[0];
          positionID = DataID[1];
        }
      } else if (
        match.url.includes("youtube") &&
        location.pathname.includes("youtube")
      ) {
        let splitPath = `/studio/${wallId}/links/youtube/`;
        let replaceData = location.pathname.replace(splitPath, "");
        let DataID = replaceData.split("/");
        if (DataID && DataID.length > 0) {
          contentMixId = DataID[0];
          positionID = DataID[1];
        }
      }
    }

    const { url, errorLink } = this.state;
    const valid_URL = validURL(url);

    if (url && url != null && url.length > 0 && valid_URL) {

     if(!errorLink){   
      this.setState({ buttonDis: true, loader: true });
      this.props.saveUrl(
        contentMixId,
        positionID,
        url,
        this.onSaveCallBack,
        this.ifError
      );
        
      }else{

    Swal.fire({
        title: "Error",
        text: `${errorLink=='youtube' ? 'Please enter only youtube url!' : errorLink=='vimeo' ? 'Please enter only vimeo url!' : 'Please enter correct url!'}`,
        type: "error",
        icon: "error",
        showConfirmButton: false,
        timer: 3000,
        });
     }
    } else {
      Swal.fire({
        title: "Error",
        text: "Please enter correct url!",
        type: "error",
        icon: "error",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };
  onBack = (event) => {
    const { params } = this.props.match;
    const { url } = this.state;
    if (url) {
      Swal.fire({
        title: "Are you sure?",
        text: "Your changes have not been saved. Do you want to save before you leave the page?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Save",
        cancelButtonText: "Discard Changes",
        reverseButtons: true,
        customClass: customClass,
      }).then((result) => {
        if (result.value) {
          this.setState({ buttonDis: true, loader: true });
          const { param } = this.props;
          const { url } = this.state;
          const valid_URL = validURL(url);
          if (url && url != null && url.length > 0 && valid_URL)
            this.props.saveUrl(
              param.contentMixId,
              param.positionID,
              url,
              this.onSaveCallBack,
              this.ifError
            );
          else {
            Swal.fire({
              title: "Error",
              text: "Please enter correct url!",
              type: "error",
              icon: "error",
              showConfirmButton: false,
              timer: 3000,
            });
          }
        } else if (result.dismiss === "cancel") {
          this.props.history(`/studio/${params.wallId}`);
        }
      });
    } else {
      this.props.history(`/studio/${params.wallId}`);
    }
  };
  onSaveCallBack = () => {
    const { params } = this.props.match;
    Swal.fire({
      title: SUCCESS_TEXT,
      text: URL_SUCCESS_SAVE,
      type: "success",
      icon: "success",
      showConfirmButton: false,
      timer: 3000,
    }).then((result) => {
      this.setState({ buttonDis: false, loader: false });
      this.props.history(`/studio/${params.wallId}`);
    });
  };

  ifError = () => {
    Swal.fire({
      title: "Error",
      text: "Please enter correct url!",
      type: "error",
      icon: "error",
      showConfirmButton: false,
      timer: 3000,
    });
  };

  render() {
    const { match, location } = this.props;
    const { url, buttonDis, loader, errorLink } = this.state;
    let GET_TEXT = "Url";

    if (location.pathname) {
      if (location.pathname.includes("vimeo")) {
        GET_TEXT = "Vimeo Url";
      } else if (location.pathname.includes("youtube")) {
        GET_TEXT = "YouTube Url";
      } else {
        GET_TEXT = "Url";
      }
    }
    return (
      <>
        <NavigationHeader
          name={GET_TEXT}
          backToNavigation={`/studio/${match.params.wallId}`}
        />
        <div className="container-fluid subheader_content">
          <Card className="select_wall mb-3 rounded-0 border-0">
            <Card.Body className="p-0">
              <Row>
                <Col lg={4} className="border-right-lg">
                  <Card className="border-0 rounded-0">
                    <Card.Body className="p-4 card_height">
                      <Form.Group controlId="formBasicEmail">
                        <Form.Label>Enter {GET_TEXT}</Form.Label>
                        <Form.Control
                          type="text"
                          className="text-url-update"
                          id="urlCng"
                          onChange={this.onTextUrl}
                          placeholder={`Enter ${GET_TEXT} `}
                        />
                      </Form.Group>
                      {GET_TEXT === "Url" ? (
                        <>
                          <p className="text-muted">
                            URL must start with https://
                          </p>
                          <p className="text-muted">
                            Some web pages might not be displayed through the
                            Studio due to their security settings.{" "}
                          </p>
                        </>
                      ) : GET_TEXT === "YouTube Url" ? (
                        <p className="text-muted">
                          Some Youtube Videos might not be played through Studio
                          due to their security settings
                        </p>
                      ) : null}
                    </Card.Body>
                    <Card.Footer className="bg-transparent d-flex justify-content-end border-0 p-4">
                      <button
                        className="btn btn-outline-dark me-3 btn-min-w"
                        onClick={this.onBack}
                      >
                        <span className="position-relative">Back</span>
                      </button>
                      <Button
                        variant="primary"
                        disabled={buttonDis}
                        className={`btn btn-primary btn-min-w ${
                          loader
                            ? `spinner spinner-white spinner-right disabled`
                            : null
                        }`}
                        onClick={this.onSaveUrl}
                      >
                        Save
                      </Button>
                    </Card.Footer>
                  </Card>
                </Col>
                <Col
                  lg={8}
                  className="d-flex align-items-center justify-content-center"
                >
                  <Card className="border-0 card w-100">
                    <Card.Body className="border-0">
                      <div className="wall_view">

                       { !errorLink  ?     
                         <div className="wall_view_wrapper">
                          { url != null && validURL(url) ? (
                            <iframe
                              className="preview-display-wall"
                              src={updateURLForIframe(url)}
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                display: "block",
                              }}
                            ></iframe>
                          ) : (
                            ""
                          )}
                          {url != null &&
                          validURL(url) &&
                          url.includes("youtube.com") ? (
                            <video
                              id="youtube_video_player"
                              width="100"
                              height="100"
                              style={{ display: "none" }}
                            >
                              <source src={url} type="video/mp4" />
                            </video>
                          ) : null}
                        </div>

                        : <div className="wall_view_wrapper studio-prieview">
                            { errorLink=='youtube' ? 'Please enter only youtube url!' : errorLink=='vimeo' ? 'Please enter only vimeo url!' : 'Please enter correct url!'}
                        </div> }

                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    studioWall: state.studio.studioWall,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    saveUrl: (contentMixId, positionID, url, callBack, ifError) =>
      dispatch(saveUrl(contentMixId, positionID, url, callBack, ifError)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateLinks);
